<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">巡更计划</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="计划名称" prop="planName">
            <el-input
              v-model="queryParams.planName"
              placeholder="请输入计划名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="巡更日期" prop="dateRange">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:60rem;"
              unlink-panels
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onReset">重 置</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>

      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添加巡更计划</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="planList"
              v-loading="loading"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="planName"
                label="计划名称"
                min-width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="patrolDate"
                label="巡更日期"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="patrolRouteName"
                label="巡更路线"
                min-width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="巡更人员"
                min-width="140"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ formatPersonList(scope.row.personList) }}
                </template>
              </el-table-column>
              <el-table-column
                label="巡更时段"
                width="160"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.patrolTimeBegin }} ~ {{ scope.row.patrolTimeEnd }}{{ scope.row.patrolTimeNextDay === 0 ? ' (次日)' : '' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="描述"
                min-width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="操作"
                width="160"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="onView(scope.row)"
                    type="text"
                    size="small"
                    >查看详细</el-button
                  >
                  <el-button
                    @click="onDelete(scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>

      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>

    <!-- 添加巡更计划弹窗 -->
    <el-dialog
      title="添加巡更计划"
      :visible.sync="addDialogVisible"
      width="700px"
      custom-class="patrol-plan-add-dialog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @closed="resetAddForm"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addRules"
        label-width="120px"
      >
        <el-form-item label="计划名称" prop="planName">
          <el-input
            v-model="addForm.planName"
            placeholder="1～32个字符，不能包含 ' / \ : * ? &quot; &lt; &gt; |"
            maxlength="32"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="巡更日期" prop="patrolDate">
          <el-date-picker
            v-model="addForm.patrolDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择巡更日期"
            style="width: 100%"
            :picker-options="datePickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="巡更路线" prop="patrolRouteId">
          <el-select
            v-model="addForm.patrolRouteId"
            filterable
            placeholder="请选择巡更路线"
            style="width: 100%"
            @change="onRouteChange"
          >
            <el-option
              v-for="item in routeOptions"
              :key="item.routeId"
              :label="item.routeName"
              :value="item.routeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡更人员" prop="personIds">
          <el-select
            v-model="addForm.personIds"
            multiple
            collapse-tags
            filterable
            placeholder="请选择巡更人员"
            style="width: 100%"
          >
            <el-option
              v-for="item in personOptions"
              :key="item.personId"
              :label="item.personName"
              :value="item.personId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡更开始时间" prop="patrolTimeBegin">
          <el-time-picker
            v-model="addForm.patrolTimeBegin"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="请选择开始时间"
            style="width: 100%"
            @change="recalcEndTime"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="巡更结束时间" prop="patrolTimeEnd">
          <el-input
            v-model="addForm.patrolTimeEnd"
            disabled
            placeholder="选择巡更路线和开始时间后自动计算"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <el-input
            v-model="addForm.remark"
            placeholder="请输入描述（1-128个字符）"
            maxlength="128"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitting"
          @click="onAddSubmit"
          >提 交</el-button
        >
      </span>
    </el-dialog>

    <!-- 详情弹窗（只读） -->
    <el-dialog
      title="巡更计划详情"
      :visible.sync="detailVisible"
      width="700px"
      :destroy-on-close="true"
    >
      <el-form label-width="120px" v-if="detailData">
        <el-form-item label="计划名称">
          <span>{{ detailData.planName }}</span>
        </el-form-item>
        <el-form-item label="巡更日期">
          <span>{{ detailData.patrolDate }}</span>
        </el-form-item>
        <el-form-item label="巡更路线">
          <span>{{ detailData.patrolRouteName }}</span>
        </el-form-item>
        <el-form-item label="巡更人员">
          <div v-if="parsedDetailPersons.length">
            <div
              v-for="(p, idx) in parsedDetailPersons"
              :key="idx"
            >
              {{ p.personName }}
            </div>
          </div>
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="巡更时段">
          <span>{{ detailData.patrolTimeBegin }} ~ {{ detailData.patrolTimeEnd }}{{ detailData.patrolTimeNextDay === 0 ? ' (次日)' : '' }}</span>
        </el-form-item>
        <el-form-item label="描述">
          <span>{{ detailData.remark || '-' }}</span>
        </el-form-item>
        <el-form-item label="发送时间" v-if="detailData.sendTime">
          <span>{{ detailData.sendTime }}</span>
        </el-form-item>
        <el-form-item label="发送人" v-if="detailData.sendUser">
          <span>{{ detailData.sendUser }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listPatrolPlan,
  getPatrolPlan,
  addPatrolPlan,
  delPatrolPlan,
  listPatrolRoute,
  getPersonMap,
  getPlanMap,
} from "../../../apis/src/PatrolInspectionApi";

// 计划名称非法字符校验
const INVALID_CHARS_REGEX = /['/\\:*?"<>|]/;
const validatePlanName = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入计划名称"));
  } else if (INVALID_CHARS_REGEX.test(value)) {
    callback(new Error("不能包含 ' / \\ : * ? \" < > | 字符"));
  } else {
    callback();
  }
};

// 巡更日期校验：≥今天
const validatePatrolDate = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请选择巡更日期"));
  } else {
    const today = new Date();
    const todayStr =
      today.getFullYear() +
      "-" +
      String(today.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(today.getDate()).padStart(2, "0");
    if (value < todayStr) {
      callback(new Error("巡更日期必须大于等于今天"));
    } else {
      callback();
    }
  }
};

export default {
  name: "PatrolPlanView",
  controller: "UI",
  action: "patrolPlanView",
  data() {
    return {
      loading: false,
      submitting: false,
      total: 0,
      planList: [],
      // 查询条件
      queryParams: {
        planName: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
      },
      dateRange: [],
      // 路线下拉
      routeOptions: [],
      // 人员下拉
      personOptions: [],
      // 日期选择器：禁止选今天之前
      datePickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },
      // 新增弹窗
      addDialogVisible: false,
      addForm: {
        planName: "",
        patrolDate: "",
        patrolRouteId: "",
        patrolRouteName: "",
        personIds: [],
        patrolTimeBegin: "",
        patrolTimeEnd: "",
        nextDay: 1,
        remark: "",
      },
      addRules: {
        planName: [
          { required: true, validator: validatePlanName, trigger: "blur" },
        ],
        patrolDate: [
          { required: true, validator: validatePatrolDate, trigger: "change" },
        ],
        patrolRouteId: [
          { required: true, message: "请选择巡更路线", trigger: "change" },
        ],
        personIds: [
          {
            required: true,
            type: "array",
            message: "请选择巡更人员",
            trigger: "change",
          },
        ],
        patrolTimeBegin: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        patrolTimeEnd: [
          {
            required: true,
            message: "请先选择巡更路线和开始时间",
            trigger: "change",
          },
        ],
      },
      // 详情弹窗
      detailVisible: false,
      detailData: null,
    };
  },
  computed: {
    parsedDetailPersons() {
      if (!this.detailData || !this.detailData.personList) return [];
      let list = this.detailData.personList;
      if (typeof list === "string") {
        try { list = JSON.parse(list); } catch (e) { return []; }
      }
      return Array.isArray(list) ? list : [];
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 加载路线下拉
    loadRoutes() {
      listPatrolRoute({ pageNum: 1, pageSize: 999 })
        .then((res) => {
          this.routeOptions = res.rows || [];
        })
        .catch((e) => console.error(e));
    },
    // 加载人员下拉
    loadPersons() {
      getPersonMap()
        .then((res) => {
          const map = res.data || {};
          this.personOptions = Object.keys(map).map((id) => ({
            personId: id,
            personName: map[id],
          }));
        })
        .catch((e) => console.error(e));
    },
    // 列表查询
    getList() {
      this.loading = true;
      const startDate =
        this.dateRange && this.dateRange[0] ? this.dateRange[0] : null;
      const endDate =
        this.dateRange && this.dateRange[1] ? this.dateRange[1] : null;
      const params = {
        planName: this.queryParams.planName || undefined,
        startTime: startDate ? `${startDate} 00:00:00` : undefined,
        endTime: endDate ? `${endDate} 23:59:59` : undefined,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
      };
      listPatrolPlan(params)
        .then((res) => {
          this.planList = res.rows || [];
          this.total = res.total || 0;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    onReset() {
      this.queryParams.planName = null;
      this.dateRange = [];
      this.queryParams.pageNum = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    // 人员列表展示
    formatPersonList(list) {
      // personList 在数据库为 TEXT 类型，可能返回字符串需安全解析
      let arr = list;
      if (typeof list === "string") {
        try { arr = JSON.parse(list); } catch (e) { arr = null; }
      }
      if (!arr || !arr.length) return "-";
      return arr.map((p) => p.personName).join("、");
    },
    // 路线选择变化
    onRouteChange(routeId) {
      const route = this.routeOptions.find((r) => r.routeId === routeId);
      this.addForm.patrolRouteName = route ? route.routeName : "";
      // 路线变化时按 duration 重新计算结束时间
      this.recalcEndTime();
    },
    // 根据 巡更路线.duration(分钟) + 开始时间 计算结束时间
    // 若结束时间跨天（>=24:00），转为次日的 HH:mm（后台据 begin>end 自动识别为次日）
    recalcEndTime() {
      const route = this.routeOptions.find(
        (r) => r.routeId === this.addForm.patrolRouteId
      );
      const begin = this.addForm.patrolTimeBegin;
      if (!route || !route.duration || !begin) {
        this.addForm.patrolTimeEnd = "";
        return;
      }
      const [h, m] = begin.split(":").map((v) => parseInt(v, 10));
      const total = h * 60 + m + Number(route.duration);
      const endH = Math.floor((total % (24 * 60)) / 60);
      const endM = total % 60;
      this.addForm.patrolTimeEnd =
        String(endH).padStart(2, "0") + ":" + String(endM).padStart(2, "0");
    },
    // 新增
    onAdd() {
      this.addDialogVisible = true;
      this.loadRoutes();
      this.loadPersons();
    },
    resetAddForm() {
      this.addForm = {
        planName: "",
        patrolDate: "",
        patrolRouteId: "",
        patrolRouteName: "",
        personIds: [],
        patrolTimeBegin: "",
        patrolTimeEnd: "",
        nextDay: 1,
        remark: "",
      };
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },
    onAddSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;

        // 时间逻辑校验：仅校验开始时间晚于当前时间
        // 结束时间由 路线duration 自动计算；若 end < begin 后台视作次日
        const { patrolDate, patrolTimeBegin } = this.addForm;
        const now = new Date();
        const beginDateTime = new Date(patrolDate + " " + patrolTimeBegin);

        if (beginDateTime <= now) {
          this.$message.warning("巡更开始时间必须大于当前时间");
          return;
        }

        // 校验计划名称唯一性：调用 getPlanMap 拿到 {planId: planName} 全量映射，精确比对 value
        this.submitting = true;
        getPlanMap()
          .then((res) => {
            const map = res.data || {};
            const dup = Object.values(map).some(
              (name) => name === this.addForm.planName
            );
            if (dup) {
              this.$message.warning("计划名称已存在，请修改后重试");
              this.submitting = false;
              return;
            }
            this.doAddSubmit();
          })
          .catch((e) => {
            console.error(e);
            this.submitting = false;
          });
      });
    },
    doAddSubmit() {
      // 组装 personList
      const personList = this.addForm.personIds.map((id) => {
        const p = this.personOptions.find((o) => o.personId === id);
        return { personId: id, personName: p ? p.personName : "" };
      });

      const body = {
        planName: this.addForm.planName,
        patrolDate: this.addForm.patrolDate,
        patrolRouteId: this.addForm.patrolRouteId,
        patrolRouteName: this.addForm.patrolRouteName,
        personList: personList,
        patrolTimeBegin: this.addForm.patrolTimeBegin,
        patrolTimeEnd: this.addForm.patrolTimeEnd,
        nextDay: this.addForm.nextDay,
        remark: this.addForm.remark || undefined,
      };
      addPatrolPlan(body)
        .then(() => {
          this.$message.success("添加成功");
          this.addDialogVisible = false;
          this.queryParams.pageNum = 1;
          this.getList();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    // 查看详情
    onView(row) {
      getPatrolPlan(row.id)
        .then((res) => {
          this.detailData = res.data || row;
          this.detailVisible = true;
        })
        .catch((e) => console.error(e));
    },
    // 删除
    onDelete(row) {
      this.$confirm("此操作将永久删除该巡更计划, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delPatrolPlan(row.id)
            .then(() => {
              this.$message.success("删除成功");
              if (
                this.planList.length === 1 &&
                this.queryParams.pageNum > 1
              ) {
                this.queryParams.pageNum -= 1;
              }
              this.getList();
            })
            .catch((e) => console.error(e));
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.patrol-plan-add-dialog {
  .el-form-item {
    margin-bottom: 28px;
  }
  .el-form-item__error {
    padding-top: 6px;
    line-height: 1.2;
    white-space: nowrap;
  }
  .el-input .el-input__count,
  .el-input .el-input__count-inner {
    background: transparent !important;
    color: inherit;
    opacity: 0.6;
  }
}
</style>
